import { WmIconDirective } from '../../shared/wm-icon.directive';

import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { TippyDirective } from '@ngneat/helipopper';

export const MODULES = [
  CommonModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDividerModule,
  MatExpansionModule,
  MatListModule,
  MatTooltipModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent];
export const DIRECTIVES = [
  TippyDirective,
  CdkDropList,
  CdkDrag,
  WmIconDirective,
];

@Component({
  selector: 'app-pigeons-settings',
  templateUrl: './pigeons-settings.component.html',
  styleUrls: ['./pigeons-settings.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...DIRECTIVES],
})
export class PigeonsSettingsComponent {
  parameterSets = input<string[]>([]);
  selectedParameterSet = input<string>(undefined);
  settingsParameters = input<Array<{ parameter: string; selected: boolean }>>(
    []
  );
  isMobilePlatform = input<boolean>(false);
  showMoreDays = input<boolean>(false);
  isUserMaster = input<boolean>(false);

  toggleTutorialVideo = output<void>();
  scrollToLegendCard = output<string>();
  openDrawer = output<string>();
  moreDays = output<void>();
  print = output<void>();

  restoreStandardSettings = output<void>();
  cancelSettings = output<void>();
  saveSettings = output<void>();
  parameterSelectionChange = output<MatSelectionListChange>();
  drop = output<any>();
  selectAllChange = output<boolean>();

  onRestoreStandardSettings(): void {
    this.restoreStandardSettings.emit();
  }

  onCancelSettings(): void {
    this.cancelSettings.emit();
  }

  onSaveSettings(): void {
    this.saveSettings.emit();
  }

  onParameterSelectionChange(event: MatSelectionListChange): void {
    this.parameterSelectionChange.emit(event);
  }

  onDrop(event: any): void {
    this.drop.emit(event);
  }

  isAllSelected(): boolean {
    const params = this.settingsParameters() ?? [];
    return params.length > 0 && params.every(entry => entry.selected);
  }

  isSomeSelected(): boolean {
    const params = this.settingsParameters() ?? [];
    const selectedCount = params.filter(entry => entry.selected).length;
    return selectedCount > 0 && selectedCount < params.length;
  }

  toggleSelectAll(checked: boolean): void {
    this.selectAllChange.emit(checked);
  }
}
